import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ICostAndQuantity } from 'safe'
import Button from '../../components/General/Button'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { addPriceAndCost } from '../../redux/actions/items'
import { tax as globalTax } from '../../userConfig'
import { formatAmount, getItemType } from '../../utils/utils'

const CostForm: React.FC<CostFormProps> = ({
  id_selected,
  cost,
  price,
  excent = false,
  items = [],
  getItems = () => { },
  itemType = 'NORMAL',
  name = 'nombre',
  onClose,
  aditionalEffect = () => { },
  onPurchase = null,
  submitText = 'Guardar',
  quantity = '0',
  loaded_quantity = '0',
  missing = '0',
  total = '0.00',
  calc_unit_cost = '0.00',
  prev_cost = null,
  disableQuantities = false,
}) => {
  const tax = excent ? Number(0) : Number(globalTax)
  let calcProfit = 20
  if (Number(price) > 0 && Number(cost) > 0) {
    calcProfit = Math.round((Number(price) / Number(cost) - 1) * 100)
  }

  const subPrice = Number((Number(price) / (1 + tax / 100)).toFixed(2))

  const originalProfit = useRef(calcProfit)
  const originalPrice = useRef(price)
  const originalSubprice = useRef(subPrice)
  const calcVariation = prev_cost
    ? ((+cost / +prev_cost - 1) * 100).toFixed(2)
    : '0.00'

  const [calcState, setCalcState] = useState<any>(() => ({
    // prev_cost: cost,
    prev_cost: onPurchase && prev_cost ? prev_cost : cost,
    cost: cost,
    variation: calcVariation,
    profit: calcProfit,
    price: subPrice,
    final_price: price,
  }))

  const [purchaseState, setPurchaseState] = useState<{
    quantity: string
    loaded_quantity: string
    missing: string
    total: string
    calc_unit_cost: string
  }>({
    quantity,
    loaded_quantity,
    missing,
    total,
    calc_unit_cost,
  })

  const { addAlert } = useSnackBars()
  const dispatch = useDispatch()

  const subHandleCost = (cost: string) => {
    const newCost = Number(cost)
    let newVariation: string | number = '0.00'
    if (Number(calcState.prev_cost) === 0) {
      newVariation = 'No calculable'
    } else {
      newVariation = Number(
        ((newCost / calcState.prev_cost - 1) * 100).toFixed(2)
      )
    }

    if (onPurchase && +calcState.prev_cost > +cost) {
      const newProfit = Math.round(
        (+originalSubprice.current / +cost - 1) * 100
      )
      setCalcState((state) => ({
        ...state,
        cost: newCost.toFixed(2),
        variation: newVariation,
        profit: newProfit,
        price: originalSubprice.current,
        final_price: originalPrice.current,
      }))
      return
    }
    const newSubPrice = Number(
      ((1 + +originalProfit.current / 100) * newCost).toFixed(2)
    )
    const newFinalPrice = Number((newSubPrice * (1 + tax / 100)).toFixed(2))

    setCalcState((state) => ({
      ...state,
      price: newSubPrice,
      cost: newCost,
      variation: newVariation,
      final_price: newFinalPrice,
      profit: originalProfit.current,
    }))
  }

  const handleCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    subHandleCost(e.target.value)
  }

  const handleProfit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newProfit = e.target.value
    const newSubPrice = (
      calcState.cost *
      (1 + Number(newProfit) / 100)
    ).toFixed(2)
    const newFinalPrice = (
      (1 + Number(tax) / 100) *
      Number(newSubPrice)
    ).toFixed(2)
    setCalcState((state) => ({
      ...state,
      price: newSubPrice,
      profit: newProfit,
      final_price: newFinalPrice,
    }))
  }

  const handleFinalPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (calcState.cost === 0) {
      const newFinalPrice = 0
      setCalcState((state) => ({
        ...state,
        final_price: newFinalPrice,
      }))
      return
    }
    const newFinalPrice = Number(e.target.value)
    const newSubPrice = Number((newFinalPrice / (1 + tax / 100)).toFixed(2))
    const newProfit = Math.round((newSubPrice / calcState.cost - 1) * 100)

    setCalcState((state) => ({
      ...state,
      price: newSubPrice,
      profit: newProfit,
      final_price: newFinalPrice,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault()
      const newCostAndPrice: ITempCostAndPrice = {
        id_item: id_selected,
        cost: calcState.cost,
        price: calcState.final_price,
      }
      if (onPurchase) {
        const pendingCosts: ICostAndQuantity = {
          id_item: id_selected,
          cost: Number(calcState.cost).toFixed(2),
          price: Number(calcState.final_price).toFixed(2),
          quantity: purchaseState.quantity,
          loaded_quantity: purchaseState.loaded_quantity,
          missing: purchaseState.missing,
          total: purchaseState.total,
          calc_unit_cost: purchaseState.calc_unit_cost,
          prev_cost: calcState.prev_cost,
        }
        if (+pendingCosts.quantity <= 0) {
          addAlert({
            message: 'Depe especificar una cantidad válidad',
            status: 'error',
          })
          return
        }
        if (+pendingCosts.total <= 0) {
          addAlert({
            message: 'Depe especificar un costo total válido',
            status: 'error',
          })
          return
        }

        if (+pendingCosts.loaded_quantity < 0) {
          addAlert({
            message:
              'Debe poseer una no negativa. Revise la cantidad y el faltante',
            status: 'error',
          })
          return
        }
        onPurchase(pendingCosts)
        return
      }
      addAlert({ message: 'Agregando costos y precios...', status: 'loading' })

      await dispatch(addPriceAndCost(newCostAndPrice))
      addAlert({ message: 'Costos y precios actualizados!', status: 'success' })
      aditionalEffect(id_selected, calcState.cost)
      getItems()
      onClose()
    } catch (error) {
      addAlert({
        message: 'Error al agregar costos y precios',
        status: 'error',
      })
      console.log('error', error)
    }
  }

  const handleQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    const quantity = e.target.value
    const loaded_quantity = String(+quantity - +purchaseState.missing)
    // setPurchaseState(prev => ({ ...prev, quantity }))
    let calc_unit_cost = ''
    if (Number(purchaseState.total) === 0) {
      calc_unit_cost = 'No calculable'
    } else {
      calc_unit_cost = (+purchaseState.total / +quantity).toFixed(2)
      subHandleCost(calc_unit_cost)
    }
    setPurchaseState((prev) => ({
      ...prev,
      calc_unit_cost,
      quantity,
      loaded_quantity,
    }))
  }

  const handleTotal = (e: React.ChangeEvent<HTMLInputElement>) => {
    const total = e.target.value
    // setPurchaseState(prev => ({ ...prev, total }))
    let calc_unit_cost = ''
    if (Number(purchaseState.quantity) === 0) {
      calc_unit_cost = 'No calculable'
    } else {
      calc_unit_cost = (+total / +purchaseState.quantity).toFixed(2)
      subHandleCost(calc_unit_cost)
    }
    setPurchaseState((prev) => ({ ...prev, calc_unit_cost, total }))
  }

  const handleMissing = (e: React.ChangeEvent<HTMLInputElement>) => {
    const missing = e.target.value
    const loaded_quantity = String(+purchaseState.quantity - +missing)
    setPurchaseState((prev) => ({ ...prev, missing, loaded_quantity }))
  }

  const compositionType =
    itemType === 'ASSEMBLY'
      ? 'productionItem'
      : itemType === 'COMPOUND'
        ? 'item'
        : itemType === 'NORMAL' || itemType === 'PRODUCTION'
          ? 'nocomposition'
          : ''

  if (compositionType === '') {
    throw new Error(`composicion no admitida, itemType =  ${itemType}`)
  }

  return (
    <div>
      <h1>Costos {`${itemType !== 'PRODUCTION' ? "y Precios" : ""}`}</h1>
      <h3
        className={`col-span-12 text-right ${getItemType(itemType).style} mb-4`}
      >
        {name}
      </h3>
      {items?.length > 0 && (
        <>
          <div className="overflow-scroll" style={{ width: '50vw' }}>
            <div
              className="grid grid-cols-12 align-top bg-transparent gap-x-6 gap-y-2 max-h-40"
              style={{ width: '940px' }}
            >
              <div className="col-start-1 col-span-5  font-bold">Nombre</div>
              <div className="col-span-1  font-bold">Exento</div>
              <div className="col-span-2  font-bold text-right">Costo U.</div>
              <div className="col-span-2  font-bold text-right">Cantidad</div>
              <div className="col-span-2  font-bold text-right">
                Costo Total
              </div>

              {items.map((composition) => (
                <React.Fragment key={composition.id}>
                  <div className="col-start-1 col-span-5  truncate">
                    {composition[compositionType].name}
                  </div>
                  <div className="col-span-1 ">
                    {composition[compositionType].exempt ? 'Sí' : 'No'}
                  </div>
                  <div className="col-span-2  text-right">
                    Bs{' '}
                    {composition[compositionType].cost
                      ? composition[compositionType].cost
                      : 0}
                  </div>
                  <div className="col-span-2  text-right">
                    {formatAmount(
                      composition.amount,
                      composition[compositionType].unit
                    )}
                  </div>
                  <div className="col-span-2  text-right">
                    Bs{' '}
                    {Number(composition.amount) *
                      Number(
                        composition[compositionType].cost
                          ? composition[compositionType].cost
                          : 0
                      )}
                  </div>
                </React.Fragment>
              ))}
              {/* <div className="col-span-12 "></div> */}
            </div>
          </div>

          <div className=" font-bold flex justify-between mb-6">
            Costo Sugerido:
            <span className="text-right font-bold text-success">
              Bs{' '}
              {items.reduce((prev, curr) => {
                prev +=
                  (curr[compositionType].cost
                    ? curr[compositionType].cost
                    : 0) * curr.amount
                return prev
              }, 0)}
            </span>
          </div>
        </>
      )}
      <form
        className="grid grid-cols-12 align-top bg-transparent gap-x-6 gap-y-2"
        onSubmit={(e) => handleSubmit(e)}
        noValidate
      >
        {onPurchase && (
          <>
            <label
              htmlFor="quantity"
              className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Cantidad:
              <input
                type="number"
                name="quantity"
                value={String(+purchaseState.quantity)}
                onChange={handleQuantity}
                className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
                style={{ width: '50%', paddingRight: 0 }}
                min="0"
                max="9999999999"
                step="0.5"
                disabled={disableQuantities}
              />
            </label>

            <label
              htmlFor="loaded_quantity"
              className={`xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center `}
            >
              A Cargar:
              <span
                className={`text-right ${+purchaseState.loaded_quantity < 0
                    ? 'text-danger'
                    : +purchaseState.loaded_quantity < +purchaseState.quantity
                      ? 'text-warning'
                      : 'text-success'
                  }`}
              >
                {' '}
                {purchaseState.loaded_quantity}
              </span>
            </label>

            <label
              htmlFor="missing"
              className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Faltante:
              <input
                type="number"
                name="missing"
                value={String(+purchaseState.missing)}
                onChange={handleMissing}
                className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
                style={{ width: '50%', paddingRight: 0 }}
                min="0"
                max="9999999999"
                step="0.5"
                disabled={disableQuantities}
              />
            </label>

            <label
              htmlFor="total"
              className="xl:col-span-6 xl:col-start-1 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Total (Bs):
              <input
                type="number"
                name="total"
                value={purchaseState.total}
                onChange={handleTotal}
                className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
                style={{ width: '50%', paddingRight: 0 }}
                min="0"
                max="9999999999"
                step="0.5"
              />
            </label>

            <label
              htmlFor="calc_unit_cost"
              className="xl:col-span-6 xl:col-start-7 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Costo Carga:
              <span className="text-right ">
                Bs {purchaseState.calc_unit_cost}
              </span>
            </label>

            <div className="mb-5 col-span-12"></div>
          </>
        )}
        <label
          htmlFor="prev_cost"
          className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
        >
          Costo Pasado:
          <span className="text-right xl:mr-6 ">Bs {calcState.prev_cost}</span>
        </label>

        <label
          htmlFor="cost"
          className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
        >
          Costo (Bs):
          <input
            type="number"
            name="cost"
            value={String(+calcState.cost)}
            onChange={(e) => handleCost(e)}
            className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
            style={{ width: '50%', paddingRight: 0 }}
            min="0"
            max="9999999999"
            step="0.5"
          />
        </label>

        <label
          htmlFor="variation"
          className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
        >
          Variación:
          <span
            className={`text-right xl:mr-6  ${calcState.cost > calcState.prev_cost &&
                Number(calcState.prev_cost) !== 0
                ? 'text-danger'
                : 'text-success'
              }`}
          >
            {calcState.cost > calcState.prev_cost &&
              Number(calcState.prev_cost) !== 0 &&
              '+'}{' '}
            {calcState.variation} %
          </span>
        </label>

        {itemType !== 'PRODUCTION' &&
          <>
            <label
              htmlFor="profit"
              className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Ganancia (%):
              {calcState.cost ? (
                <input
                  type="number"
                  name="profit"
                  value={String(+calcState.profit)}
                  onChange={(e) => handleProfit(e)}
                  className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
                  style={{ width: '50%', paddingRight: 0 }}
                  min="0"
                  max="9999999999"
                />
              ) : (
                <p className="text-right text-sm text-warning">No calculable</p>
              )}
            </label>

            <>
              <label
                htmlFor="tax"
                className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
              >
                Impuesto:
                <span className={`text-right  xl:mr-6`}>
                  {excent ? 'Excento' : tax + ' %'}
                </span>
              </label>
            </>

            {!excent && (
              <>
                <label
                  htmlFor="final_price"
                  className="xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
                >
                  Precio sin iva:
                  <span className=" text-right ">Bs {calcState.price}</span>
                </label>
              </>
            )}

            <label
              htmlFor="price"
              className="xl:col-start-7 xl:col-span-6 col-span-12 h-7 font-medium text-primary-900  dark:text-white flex justify-between items-center"
            >
              Precio Final (Bs):
              <input
                type="number"
                name="price"
                value={String(+calcState.final_price)}
                onChange={(e) => handleFinalPrice(e)}
                className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7"
                style={{ width: '50%', paddingRight: 0 }}
                min="0"
                max="9999999999"
                step="0.5"
              />
            </label>


          </>
        }




        <div className='h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5'></div>

        <div className="col-span-12 flex space-x-2 px-1 mt-5 block">
          {onClose && (
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => onClose()}
              htmlType="button"
            >
              Cancelar
            </Button>
          )}
          <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
            {submitText}
          </Button>
        </div>
      </form>
    </div>
  )
}

interface CostFormProps {
  id_selected: string
  cost: string
  price: string
  excent?: boolean
  onClose: Function
  getItems?: Function
  itemType?: 'COMPOUND' | 'ASSEMBLY' | 'PRODUCTION' | 'NORMAL'
  name: String
  items?: any[]
  aditionalEffect?: Function
  onPurchase?: Function
  submitText?: string

  quantity?: string
  loaded_quantity?: string
  missing?: string
  total?: string
  calc_unit_cost?: string
  prev_cost?: string

  disableQuantities?: boolean
}

export interface ITempCostAndPrice {
  id_item: string
  cost: string
  price: string
}

export default CostForm
